export default __webpack_public_path__ + "static/lozenge-do-4-light-6d8317a455d6aea8300d5f22acb81fd0d2f5259f66f37c90fe365afbbf3ff1b7.png";